import { Spacing } from '@persona-id/design-tokens';
import { ArrayFieldTemplateItemType, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${Spacing[1]};
`;

/** The `ArrayFieldItemTemplate` component is the template used to render an items of an array.
 *
 * @param props - The `ArrayFieldTemplateItemType` props for the component
 */
export function ArrayFieldItemTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  props: ArrayFieldTemplateItemType<T, S, F>,
) {
  const { children, disabled, hasToolbar, hasRemove, onDropIndexClick, readonly, index } = props;

  return (
    <Card>
      <Card.Body>
        {children}
        {hasToolbar && !readonly && (
          <ButtonContainer>
            {hasRemove && (
              <Button
                width='auto'
                variant='basic'
                onClick={onDropIndexClick(index)}
                disabled={disabled}
              >
                Remove entry
              </Button>
            )}
          </ButtonContainer>
        )}
      </Card.Body>
    </Card>
  );
}
